<div class="setup-container">
  <div class="setup-header">
    <i class="bi bi-gear"></i>
    <span>Setup</span>
  </div>

  <form [formGroup]="resumeForm">
    <div class="field">
      <label>Target Role / Field <span>(optional)</span></label>
      <input
        type="text"
        placeholder="e.g. Software Developer, Data Analyst..."
        formControlName="target_role"
      />
    </div>

    <div class="field">
      <label><i class="bi bi-camera"></i> Include Photo?</label>

      <div class="toggle-separate">
        <button
          class="toggle-btn"
          [class.active]="includePhoto === false"
          (click)="setPhoto(false)"
        >
          No
        </button>

        <button
          class="toggle-btn"
          [class.active]="includePhoto === true"
          (click)="setPhoto(true)"
        >
          Yes
        </button>
      </div>
    </div>

    <div class="upload-row mb-3" *ngIf="includePhoto">
      <div class="upload-icon">
        <img *ngIf="previewUrl; else cameraIcon" [src]="previewUrl" />

        <ng-template #cameraIcon>
          <i class="bi bi-camera"></i>
        </ng-template>
      </div>

      <input
        type="file"
        #fileInput
        accept="image/jpeg, image/jpg"
        hidden
        (change)="onFileSelected($event)"
      />

      <button class="upload-btn" (click)="fileInput.click()">
        <i class="bi bi-upload"></i>
        {{ previewUrl ? "Change Photo" : "Upload Photo" }}
      </button>

      <span class="upload-text">JPG/JPEG only, max 5MB</span>
    </div>

    <div class="field">
      <label
        ><i class="bi bi-file-earmark"></i> Choose Template
        <span class="req"> *</span></label
      >

      <div class="template-list">
        <div
          class="template-card"
          *ngFor="let t of templates"
          [class.selected]="selectedTemplate === t.name"
          (click)="selectTemplate(t.name)"
        >
          <div
            class="template-preview"
            [ngClass]="t.type"
            [ngStyle]="{ '--themeColor': selectedColor }"
            [ngSwitch]="t.name"
          >
            <ng-container *ngSwitchCase="'Classic'">
              <div class="prev-header-row">
                <div class="prev-avatar"
                  *ngIf="includePhoto">
                      <div class="dummy-avatar"></div>
                </div>
                <div class="prev-header-text">
                  <div class="prev-name-line"></div>
                  <div class="prev-role-line"></div>
                </div>
              </div>
              <div class="prev-divider"></div>
              <div class="prev-section-title"></div>
              <div class="prev-line"></div>
              <div class="prev-line short"></div>
              <div class="prev-section-title"></div>
              <div class="prev-line"></div>
              <div class="prev-line short"></div>
            </ng-container>

            <ng-container *ngSwitchCase="'Modern'">
              <div class="prev-header-row">
                <div
                  class="prev-avatar"
                  *ngIf="includePhoto">
                  <div class="dummy-avatar"></div>
                  </div>
                <div class="prev-header-text">
                  <div class="prev-name-line wide"></div>
                  <div class="prev-role-line"></div>
                </div>
              </div>
              <div class="prev-divider thick"></div>
              <div class="prev-section-title"></div>
              <div class="prev-line"></div>
              <div class="prev-line short"></div>
              <div class="prev-section-title"></div>
              <div class="prev-line"></div>
              <div class="prev-line short"></div>
            </ng-container>

            <ng-container *ngSwitchCase="'Minimal'">
              <div class="prev-header-row">
                <div
                  class="prev-avatar"
                  *ngIf="includePhoto">
                   <div class="dummy-avatar"></div>
              </div>
                <div class="prev-header-text">
                  <div class="prev-name-line"></div>
                  <div class="prev-role-line"></div>
                </div>
              </div>
              <div class="prev-divider thin"></div>
              <div class="prev-section-title"></div>
              <div class="prev-line"></div>
              <div class="prev-line short"></div>
              <div class="prev-section-title"></div>
              <div class="prev-line"></div>
              <div class="prev-line short"></div>
            </ng-container>

            <ng-container *ngSwitchCase="'Professional'">
              <div class="prev-header-block">
                <div
                  class="prev-avatar white-avatar"
                  *ngIf="includePhoto">
                   <div class="dummy-avatar"></div>
              </div>
                <div class="prev-header-text">
                  <div class="prev-name-line white"></div>
                  <div class="prev-role-line white-dim"></div>
                </div>
              </div>
              <div class="prev-section-title"></div>
              <div class="prev-line"></div>
              <div class="prev-line short"></div>
              <div class="prev-section-title"></div>
              <div class="prev-line"></div>
            </ng-container>

            <ng-container *ngSwitchCase="'Sidebar'">
              <div class="prev-sidebar-left">
                <div
                  class="prev-avatar white-avatar sm"
                  *ngIf="includePhoto"
                ><div class="dummy-avatar"></div>
              </div>
                <div class="prev-section-title white"></div>
                <div class="prev-line white-dim"></div>
                <div class="prev-line white-dim short"></div>
                <div class="prev-section-title white"></div>
                <div class="prev-line white-dim"></div>
              </div>
              <div class="prev-sidebar-right">
                <div class="prev-name-line"></div>
                <div class="prev-role-line"></div>
                <div class="prev-line"></div>
                <div class="prev-line short"></div>
                <div class="prev-line"></div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'Executive'">
              <div class="prev-exec-left">
                <div class="prev-header-row">
                  <div
                    class="prev-avatar sm"
                    *ngIf="includePhoto"
                  ><div class="dummy-avatar"></div>
                  </div>
                  <div class="prev-header-text">
                    <div class="prev-name-line"></div>
                    <div class="prev-role-line"></div>
                  </div>
                </div>
                <div class="prev-section-title"></div>
                <div class="prev-line"></div>
                <div class="prev-line short"></div>
                <div class="prev-section-title"></div>
                <div class="prev-line"></div>
                <div class="prev-line short"></div>
              </div>
              <div class="prev-exec-divider"></div>
              <div class="prev-exec-right">
                <div class="prev-section-title"></div>
                <div class="prev-line short"></div>
                <div class="prev-line shorter"></div>
                <div class="prev-section-title"></div>
                <div class="prev-line short"></div>
                <div class="prev-line shorter"></div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'Creative'">
              <div class="prev-creative-left">
                <div
                  class="prev-avatar white-avatar sm"
                  *ngIf="includePhoto"
                ><div class="dummy-avatar"></div>
                </div>
                <div class="prev-line white-dim"></div>
                <div class="prev-line white-dim short"></div>
                <div class="prev-line white-dim"></div>
                <div class="prev-line white-dim short"></div>
              </div>
              <div class="prev-creative-right">
                <div class="prev-name-line"></div>
                <div class="prev-line"></div>
                <div class="prev-line short"></div>
                <div class="prev-section-title"></div>
                <div class="prev-line"></div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'Compact'">
              <div class="prev-compact-header">
                <div
                  class="prev-avatar sm"
                  *ngIf="includePhoto"
                ><div class="dummy-avatar"></div>
              </div>
              </div>
              <div class="prev-compact-cols">
                <div class="prev-compact-left">
                  <div class="prev-section-title"></div>
                  <div class="prev-line short"></div>
                  <div class="prev-line shorter"></div>
                  <div class="prev-section-title"></div>
                  <div class="prev-line short"></div>
                  <div class="prev-line shorter"></div>
                  <div class="prev-section-title"></div>
                  <div class="prev-line short"></div>
                </div>
                <div class="prev-compact-divider"></div>
                <div class="prev-compact-right">
                  <div class="prev-line"></div>
                  <div class="prev-line short"></div>
                  <div class="prev-line"></div>
                  <div class="prev-section-title"></div>
                  <div class="prev-line"></div>
                  <div class="prev-line short"></div>
                  <div class="prev-line"></div>
                  <div class="prev-section-title"></div>
                  <div class="prev-line short"></div>
                  <div class="prev-line"></div>
                </div>
              </div>
            </ng-container>
          </div>

          <div class="template-info">
            <p>{{ t.name }}</p>
            <span>{{ t.type }}</span>
          </div>
        </div>
      </div>

      <small
        class="text-danger"
        *ngIf="
          resumeForm.get('template_id')?.invalid &&
          resumeForm.get('template_id')?.touched
        "
        >Template is required</small
      >
    </div>

    <div class="field">
      <label>Color Theme <span class="req"> *</span></label>

      <div class="color-list">
        <div
          *ngFor="let c of colors"
          class="color-item"
          [style.background]="c"
          [class.active]="selectedColor === c"
          (click)="selectColor(c)"
        ></div>
      </div>
      <small
        class="text-danger"
        *ngIf="
          resumeForm.get('theme_color')?.invalid &&
          resumeForm.get('theme_color')?.touched
        "
        >Color is required
      </small>
    </div>
  </form>
</div>
